import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import MovieCard from "@/components/base/MovieCard";
import NewsCard from "@/components/base/NewsCard";
import HeroCarousel from "./components/HeroCarousel";
import QuickCategories from "./components/QuickCategories";
import HomeSidebar from "./components/HomeSidebar";
import { movies } from "@/mocks/movies";
import { newsList } from "@/mocks/news";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "姐姐的朋友 - 精品影视资源与剧情介绍",
    description:
      "姐姐的朋友网站提供丰富的影视剧资源，包括剧情介绍和相关资讯，满足用户对影视内容的全面了解与观看需求。",
    keywords: "姐姐的朋友,影视资源,剧情介绍,电视剧,电影,影视资讯,影视剧推荐",
  });

  const featured = movies.filter((movie) => movie.featured);
  const latest = [...movies].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 6);
  const newsFeatures = newsList.slice(0, 3);

  return (
    <div className="min-h-screen bg-background-100">
      <SiteHeader />
      <main>
        <HeroCarousel items={featured} />
        <QuickCategories />

        <div className="mx-auto w-full max-w-[1400px] px-4 py-8 md:px-6 md:py-12">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
            <div className="lg:col-span-8">
              <div className="flex flex-wrap items-end justify-between gap-3">
                <div>
                  <p className="font-label text-[11px] tracking-[0.26em] text-foreground-400">LATEST RELEASES</p>
                  <h2 className="mt-1 flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
                    <span className="h-5 w-1 rounded-full bg-accent-500" />
                    最新影视剧
                  </h2>
                  <p className="mt-2 text-xs text-foreground-500">按更新时间收录，剧情简介与详情页内容保持一致</p>
                </div>
                <Link
                  to="/category?sort=updated"
                  className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  查看全部
                  <i className="ri-arrow-right-line text-sm" />
                </Link>
              </div>

              <div className="mt-5 grid grid-cols-2 gap-4 xl:grid-cols-3">
                {latest.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} compact />
                ))}
              </div>

              <section className="mt-8 overflow-hidden rounded-lg bg-primary-950">
                <div className="flex flex-col gap-5 p-6 md:flex-row md:items-center md:justify-between md:p-8">
                  <div className="max-w-xl">
                    <p className="font-label text-[10px] tracking-[0.26em] text-accent-400">WEEKLY COLLECTION</p>
                    <h3 className="mt-2 text-lg font-bold text-background-50 md:text-xl">本周片单：写给「告别」的六个故事</h3>
                    <p className="mt-2 text-sm leading-7 text-primary-200">
                      从《潮汐之城》到《旧日邮局》，我们挑出六部关于告别的作品，适合在安静的夜里一次看完。
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2">
                      {["告别", "治愈", "慢节奏"].map((tag) => (
                        <span
                          key={tag}
                          className="rounded-full border border-primary-700 px-2.5 py-1 text-[11px] text-primary-200"
                        >
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <Link
                    to="/category?sort=score"
                    className="inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
                  >
                    查看片单
                    <i className="ri-arrow-right-line text-base" />
                  </Link>
                </div>
              </section>
            </div>

            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-24">
                <HomeSidebar />
              </div>
            </div>
          </div>

          <section className="mt-10 md:mt-14">
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <p className="font-label text-[11px] tracking-[0.26em] text-foreground-400">FILM JOURNAL</p>
                <h2 className="mt-1 flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
                  <span className="h-5 w-1 rounded-full bg-primary-500" />
                  影视资讯
                </h2>
                <p className="mt-2 text-xs text-foreground-500">行业动态、新片报道与主创访谈，每周持续更新</p>
              </div>
              <Link
                to="/news"
                className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                全部资讯
                <i className="ri-arrow-right-line text-sm" />
              </Link>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
              {newsFeatures.map((item) => (
                <NewsCard key={item.id} item={item} variant="feature" />
              ))}
            </div>
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}